// Integrytas Group - Common Security Module (CSM)
// Personalization type definitions.

export interface FieldPreference {
  visible:  boolean;
  readonly: boolean;
  required: boolean;
}

export interface ColumnPreference {
  visible: boolean;
  width:   number | undefined;
  order:   number;
}

export interface GridPreference {
  columns: Record<string, Partial<ColumnPreference>>;
}

export interface FormPreference {
  fields: Record<string, Partial<FieldPreference>>;
}

export type ComponentPreference = GridPreference | FormPreference;

export interface UiPreferenceRow {
  preference_id?:  number;
  user_id?:        number | null;
  role_id?:        number | null;
  page_code:       string;
  component_key:   string;
  preference_json: Record<string, unknown>;
}

export const DEFAULT_FIELD_PREF: FieldPreference  = { visible: true, readonly: false, required: false };
export const DEFAULT_COL_PREF:   ColumnPreference = { visible: true, width: undefined, order: 0 };
